module.exports = __webpack_public_path__ + "static/media/r24.8214e14a.jpg";